import { ApplicationData, ApplicationDataStore } from '../application/ApplicationDataStore';
import { SaveFormDataToStore } from '../application/SaveFormDataToStore';
import { Form, FormProps } from '../common/Form';
import { schema } from './schema';
import { ServicePropertyFields } from './ServicePropertyFields';
import { useEffect } from 'react';

export const Container = (
    props: Omit<
        FormProps<ApplicationData['serviceProperty']>,
        'schema' | 'defaultValues' | 'formData' | 'children'
    >,
) => {
    const { applicationData, setApplicationData } = ApplicationDataStore.useStore();

    useEffect(() => {
        if (applicationData.mailingAddress?.workPerformedAtAddress) {
            delete applicationData.serviceProperty?.address;
            setApplicationData(prev => ({
                ...prev,
                serviceProperty: applicationData.serviceProperty,
            }));
        }
    }, [
        applicationData.mailingAddress?.workPerformedAtAddress,
        applicationData.serviceProperty,
        setApplicationData,
    ]);

    return (
        <Form
            {...props}
            formData={{
                ...applicationData.serviceProperty!,
                workPerformedAtAddress: applicationData.mailingAddress?.workPerformedAtAddress,
            }}
            schema={schema}
        >
            <SaveFormDataToStore fieldPrefix="serviceProperty" />
            <ServicePropertyFields />
        </Form>
    );
};
